import React, { useState, useRef, useEffect } from 'react';

/**
 * LazyItem component delays rendering of its children until it becomes visible in the viewport.
 * It uses Intersection Observer to detect when at least 10% of the component is visible,
 * then renders the children, improving performance by lazy-loading content as the user scrolls.
 */
export const LazyItem = ({ children }: { children: React.ReactNode }) => {
    const [isVisible, setIsVisible] = useState(false);
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.disconnect();
                }
            },
            { threshold: 0.1 }
        );

        if (ref.current) observer.observe(ref.current);
        return () => observer.disconnect();
    }, []);

    return <div ref={ref} style={{ minHeight: 60 }}>{isVisible ? children : null}</div>;
};